import { useStore } from '@xyflow/react'
import { FlowTypes } from 'v2/types'
import { CALL_PLACING_NODE_TYPES } from '../config/contact-screening.config'
import { useFlowStore } from '../store'

export const useHasVoiceNode = () => {
  const currentFlowType = useFlowStore((state) => state.currentFlowType)
  const hasInitiateCall = useStore((state) =>
    state.nodes.some((node) => CALL_PLACING_NODE_TYPES.has(node.type ?? '')),
  )

  return currentFlowType === FlowTypes.incoming_call || hasInitiateCall
}
